import React, { useState } from "react";
import {
  Box,
  Stack,
  TextField,
  InputAdornment,
} from "@mui/material";

import { useNavigate } from "react-router-dom";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import PaymentOutlinedIcon from "@mui/icons-material/PaymentOutlined";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import DriveFileRenameOutlineOutlinedIcon from "@mui/icons-material/DriveFileRenameOutlineOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";

import { doc, setDoc } from "firebase/firestore";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { auth, firestore } from "../services/firebase";
import CustomButton from "../components/CustomButton";

import { Link } from "react-router-dom";

const API_URL = process.env.REACT_APP_API_URL

const CreateAccount = () => {
  const navigate = useNavigate();
  const [userName, setuserName] = useState("");
  const [payPalHandle, setPaypalHandle] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleCreateAccount = async(e) => {
    if (userName && password && email) {
      e.preventDefault();
      await createUserWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        const { user } = userCredential;
        fetch(`${API_URL}/firebase/save-user`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            userEmail: user.email,
            UID: user.uid,
            userName,
            payPalHandle,
          })
        })
        navigate("/Login");
      })
      .catch((error) => {});
    } else {
      setError("userName and password are required.");
    }
  };

  const clearInput = (inputField) => {
    switch (inputField) {
      case "userName":
        setuserName("");
        break;
      case "payPalHandle":
        setPaypalHandle("");
        break;
      case "email":
        setEmail("");
        break;
      case "password":
        setPassword("");
        break;
      default:
        break;
    }
  };
  return (
    <Box className="max_container">
      <Stack spacing={2} className="mt-20 mb-4">
        {/* usename textfield  */}
        <TextField
          id="input-with-icon-textfield"
          label="userName"
          placeholder="input"
          fullWidth
          value={userName}
          onChange={(e) => setuserName(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <DriveFileRenameOutlineOutlinedIcon />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                <HighlightOffIcon
                  onClick={() => clearInput("userName")}
                  style={{ cursor: "pointer" }}
                />
              </InputAdornment>
            ),
          }}
          variant="outlined"
        />
        {/* paypal acount input  */}
        <TextField
          id="input-with-icon-textfield"
          label="Paypal handle"
          placeholder="i.e josuguti02"
          fullWidth
          value={payPalHandle}
          onChange={(e) => setPaypalHandle(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <PaymentOutlinedIcon />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                <HighlightOffIcon
                  onClick={() => clearInput("payPalHandle")}
                  style={{ cursor: "pointer" }}
                />
              </InputAdornment>
            ),
          }}
          variant="outlined"
        />
        {/* email  input*/}
        <TextField
          id="input-with-icon-textfield"
          label="Email"
          placeholder="input"
          fullWidth
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <EmailOutlinedIcon />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                <HighlightOffIcon
                  onClick={() => clearInput("email")}
                  style={{ cursor: "pointer" }}
                />
              </InputAdornment>
            ),
          }}
          variant="outlined"
        />

        {/* Password input  */}
        <TextField
          id="input-with-icon-textfield"
          label="Password"
          type="password"
          placeholder="input"
          fullWidth
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <LockOutlinedIcon />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                <HighlightOffIcon
                  onClick={() => clearInput("password")}
                  style={{ cursor: "pointer" }}
                />
              </InputAdornment>
            ),
          }}
          variant="outlined"
        />
      </Stack>
      {/* Buttons */}
      <Stack spacing={2} className="my-32 px-12">
        <CustomButton 
          // myFunction={handleCreateAccount}
          myFunction={() => alert("Sign Up is currently unavailable, contact us to get an account")}
          text={"Create Account"}
        />
        <div>
          Already have an account?
          <Link to="/login">Login</Link>
        </div>
      </Stack>
    </Box>
  );
};

export default CreateAccount;
